import axios from 'axios';
import { signOut } from 'firebase/auth';
import { message } from 'antd';
import i18n from '../i18n';
import store from '../redux/store/store';
import { auth } from './firebase_authentications';
import { SettingsReducer } from '../redux/Setting';
import { getAuthTokenWithOutSignUp } from "../apis/PostData";

const SettingActions = SettingsReducer.actions;

// Create a new Axios instance with custom configuration
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


// Request interceptor

instance.interceptors.request.use(
  (config) => {
    
    const firebaseToken = store.getState().settings.firebaseToken; // Get the Firebase token from the Redux store
    if (firebaseToken) {
      // Add the Firebase token to the request headers
      config.headers.Authorization = `Bearer ${firebaseToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // check if the messageCode is USER_NOT_FOUND — same logout flow as AccountDropDown handleLogout
    const messageCode = error.response?.data?.messageCode || error.response?.messageCode;
    if (messageCode === "USER_NOT_FOUND") {
      signOut(auth)
        .then(() => {
          const selectedTranslations = store.getState().settings.selectedTranslations || [];
          const selectedTranslationsWithFirst2Values = selectedTranslations.slice(0, 2);
          store.dispatch(SettingActions.resetSettings());
          store.dispatch(SettingActions.updateSettings({ selectedTranslations: selectedTranslationsWithFirst2Values }));
          store.dispatch(SettingActions.updateSettings({ firebaseToken: null }));
          window.location.href = '/';
          message.warning(i18n.t('session-expired-sign-in-again'));
        })
      return Promise.reject(error);
    }


    // Check if the error is due to an expired token
    if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest?._retry) {
      originalRequest._retry = true;
      // Refresh the token
      getAuthTokenWithOutSignUp(auth.currentUser)
      .then(newAccessToken => {
        store.dispatch(SettingsReducer.actions.updateSettings({ firebaseToken: newAccessToken }));
        if (newAccessToken) {
        // Update the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      }
      })
      .catch(error => {
        // console.error("Error:", error);
      });
      // Retry the original request
      return instance(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default instance;
